<template>
  <div class="close" v-on:click="exit">
    <span>Exit IC Health Check</span>
  </div>
</template>

<script>
export default {
  name: "CloseButton",
  methods: {
    exit() {
      let response = confirm(
        "Are you sure you want to exit the IC Health Check?\nYour answers will not be saved."
      );
      if (response) {
        window.location.href = "/";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.close {
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 7px 14px;
  width: 21px;
  height: 27px;

  background: {
    image: url("../../../assets/images/health-check-close-button.svg");
    size: 11px;
    position: center;
    repeat: no-repeat;
  }

  span {
    display: none;
  }

  @media (min-width: 768px) {
    top: 48px;
    right: 22px;
    padding: 0;
    background: none;
    font-size: 16px;
    letter-spacing: -0.3px;
    width: 100%;
    text-align: right;
    color: #0000ff;
    cursor: pointer;

    span {
      display: block;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
